import {StorageService} from '../../index';
import {StorageKeyType} from './storage-keys';
import {StorageType} from './storage.type';

export class StorageKeyTargetController {
	public storageTypesMap: Map<StorageKeyType, StorageType> = new Map();
	constructor(private storageService: StorageService) {
		this.initAllStorages();
	}

	initAllStorages(): void {
		// localStorage
		const localStorageKeys = Object.keys(localStorage.getAll());
		localStorageKeys.forEach(key => {
			this.storageTypesMap.set(key as StorageKeyType, StorageType.LOCAL);
		});
		// sessionStorage
		const sessionStorageKeys = Object.keys(sessionStorage.getAll());
		sessionStorageKeys.forEach(key => {
			this.storageTypesMap.set(key as StorageKeyType, StorageType.SESSION);
		});
	}
}
